import { render, staticRenderFns } from "./Opciones.vue?vue&type=template&id=80501132"
import script from "./Opciones.vue?vue&type=script&lang=js"
export * from "./Opciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports